import { ButtonPrimary } from 'components/Button/Button'
import { StyledHeader, StyledInnerWrapper } from './steps/SelectType'
import TypographyPrimary from 'components/Typography/Primary'
import TypographySecondary from 'components/Typography/Secondary'
import { t } from 'i18next'

const GetStarted = ({ handleSwitchToAccount }: { handleSwitchToAccount: () => void }) => {
    return (
        <StyledInnerWrapper>
            <StyledHeader>
                <TypographyPrimary value={`All Done! `} size='x-large' bold />
                <TypographySecondary value={t('new-app-get-started')} size='medium' />
            </StyledHeader>

            <ButtonPrimary onClick={handleSwitchToAccount}>Continue</ButtonPrimary>
        </StyledInnerWrapper>
    )
}

export default GetStarted
